import React, { useEffect, useRef, useState } from 'react'
import List from '@mui/material/List';

import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { Box, Tooltip, Typography, Fade } from '@mui/material'
import { NavLink, useLocation } from 'react-router-dom'
import { Collapse } from 'react-collapse';
import * as RiIcons from 'react-icons/ri'
import { setCurrentlyOpendMenuItem, setIsOpenSideMenu, setcurrentOpenMenuCollapse } from '../reduxStore/SettingsReducer';
import { selectRoles } from '../reduxStore/RolesReducer';


export default function SideMenuItemArray({
  open,
  setOpen,
  pathsList,
  setPathList,
  MainContainerRef,
}) {
  const maintheme = useSelector((state) => state.themeData.maintheme);
  const listRef = useRef(null);
  const location = useLocation();
  const [t] = useTranslation("common");
  const sidemenutheme = useSelector(state => state.themeData.sidemenutheme)
  const dispatch = useDispatch()
  // const [openCollapse,setOpenCollapse]=useState(false)
  const rolesRedux = useSelector(selectRoles)
  const [paths, setPaths] = useState(pathsList?.length ? pathsList : [])
  const isopensidemenu = useSelector(
    (state) => state.settingsData.isopensidemenu
  );
  const currentOpenMenuCollapse = useSelector(
    (state) => state.settingsData.currentOpenMenuCollapse
  );
  const currentlyOpenedMenuItem = useSelector(
    (state) => state.settingsData.currentlyOpenedMenuItem
  );
  useEffect(() => {

    setPaths(pathsList?.length ? pathsList : [])

    return () => {

    }
  }, [pathsList])


  useEffect(() => {

    if (currentOpenMenuCollapse && pathsList?.length) {


      let data = handleOpenOrClose(currentOpenMenuCollapse, pathsList);
      if (data && data?.length > 0) {
        setPathList(data);
      }
    }
  }, [currentOpenMenuCollapse]);
  const openCollapseToggle = (path, event) => {

    dispatch(setIsOpenSideMenu(true));


    if (!isopensidemenu) {


      dispatch(setCurrentlyOpendMenuItem(path));

      if (!path?.openCollapse) {
        dispatch(setcurrentOpenMenuCollapse(path?.id));

      }
    } else dispatch(setcurrentOpenMenuCollapse(path?.id));

    handleClick(event)


  }
  const handleOpenOrClose = (id, dataList) => {
    var arr = [];
    dataList &&
      dataList?.length > 0 &&
      dataList?.map((itm) => {
        if (itm?.subLink?.length > 0) {
          if (itm?.id == id) {
            arr.push({
              ...itm,
              openCollapse: itm?.openCollapse == true ? false : true,
            });
          } else {
            let object = itm;
            let subArr = [];
            itm?.subLink &&
              itm?.subLink?.length > 0 &&
              itm?.subLink?.map((itm2) => {
                if (itm2?.subLink?.length > 0) {
                  if (itm2?.id == id) {
                    subArr.push({
                      ...itm2,
                      openCollapse: itm2?.openCollapse == true ? false : true,
                    });
                  } else {
                    subArr.push(itm2);
                  }
                } else {
                  subArr.push(itm2);
                }
              });
            if (subArr?.length) {
              object = {
                ...itm,
                subLink: subArr,
              };
              arr.push(object);
            }
            //  handleOpenOrClose(id,itm?.subLink,itm?.id)
          }
        } else {
          arr.push(itm);
        }
      });

    dispatch(setcurrentOpenMenuCollapse(null));
    return arr;
  };
  const getCurrentHeightInList = (pathsList, id, pathName) => {
    //  var Hvalue=5,lock=false;
    //  pathsList&&pathsList?.map(item=>{
    //   if(id&&id!=item?.id&&!lock&&!pathName){
    //     if(item?.subLink?.length){
    //       if(item?.openCollapse){
    //       if(item?.subLink?.length>10)
    //         Hvalue=-150
    //       }
    //     }
    //   }else if(pathName&&pathName!='/system/'+item?.to&&!lock&&!id){
    //     if(item?.subLink?.length){
    //       if(item?.openCollapse){
    //       if(item?.subLink?.length>10)
    //         Hvalue=-150
    //       }
    //     }
    //   }else{
    //     lock=true;
    //   }
    //  })
    return 5;
  }
  useEffect(
    () => {
      // Scroll to the selected menu item when it changes

      if (
        currentlyOpenedMenuItem &&
        currentlyOpenedMenuItem?.ref &&
        isopensidemenu &&
        MainContainerRef?.current
      ) {

        let countH = getCurrentHeightInList(pathsList, currentlyOpenedMenuItem?.id, null)
        setTimeout(() => {
          const container =
            MainContainerRef && MainContainerRef?.current
              ? MainContainerRef?.current
              : null;
          const selectedItemElement =
            currentlyOpenedMenuItem &&
              currentlyOpenedMenuItem?.ref &&
              currentlyOpenedMenuItem?.ref?.current
              ? currentlyOpenedMenuItem?.ref?.current
              : null;
          const scrollOffset =
            selectedItemElement && selectedItemElement?.offsetTop
              ? selectedItemElement?.offsetTop
              : null;
          if (container && scrollOffset != null)
            container.scrollTop = scrollOffset - countH;

        }, 50);
      } else if (!currentlyOpenedMenuItem && isopensidemenu) {

        let countH = getCurrentHeightInList(pathsList, null, location.pathname)

        pathsList &&
          pathsList?.map((item) => {
            if (item?.subLink && item?.subLink?.length) {


              item?.subLink?.map((subItem) => {
                if (
                  `/system/${subItem?.to}` == location.pathname &&
                  subItem?.ref
                ) {
                  setTimeout(() => {
                    dispatch(setcurrentOpenMenuCollapse(subItem?.id));
                    dispatch(setCurrentlyOpendMenuItem(subItem));
                    // dispatch(setCopyOfcurrentOpenMenuItem(subItem));
                    const container =
                      MainContainerRef && MainContainerRef?.current
                        ? MainContainerRef?.current
                        : null;
                    const selectedItemElement =
                      subItem && subItem?.ref && subItem?.ref?.current
                        ? subItem?.ref?.current
                        : null;
                    const scrollOffset =
                      selectedItemElement && selectedItemElement?.offsetTop
                        ? selectedItemElement?.offsetTop
                        : null;


                    if (container && scrollOffset != null)
                      container.scrollTop = scrollOffset - countH;
                  }, 50);
                }
              });
            } else {

              let countH = getCurrentHeightInList(pathsList, null, location.pathname)

              if (
                `/system/${item?.to}` == location.pathname &&
                item?.ref
              ) {
                setTimeout(() => {
                  dispatch(setcurrentOpenMenuCollapse(item?.id));
                  dispatch(setCurrentlyOpendMenuItem(item));
                  // dispatch(setCopyOfcurrentOpenMenuItem(item));
                  const container =
                    MainContainerRef && MainContainerRef?.current
                      ? MainContainerRef?.current
                      : null;
                  const selectedItemElement =
                    item && item?.ref && item?.ref?.current
                      ? item?.ref?.current
                      : null;
                  const scrollOffset =
                    selectedItemElement && selectedItemElement?.offsetTop
                      ? selectedItemElement?.offsetTop
                      : null;


                  if (container && scrollOffset != null)
                    container.scrollTop = scrollOffset - countH;
                }, 50);
              }
            }
          });
      }
    },
    !currentlyOpenedMenuItem
      ? [currentlyOpenedMenuItem, isopensidemenu, pathsList]
      : [currentlyOpenedMenuItem, isopensidemenu]
  );

  const openCollapseToggle2 = (obj) => {
    setOpen(true)
    dispatch(setIsOpenSideMenu(true));
    dispatch(setcurrentOpenMenuCollapse(obj?.id));
    dispatch(setCurrentlyOpendMenuItem(obj));
  };
  const handleClick = (event) => {
    if (event && event?.target) {
      const listItem = event?.target
      if (listItem) {
        const offsetTop = listItem?.offsetTop;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth',
        });
      }
    }
  };
  return (
    <List
      sx={{
        height: "fit-content !important",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "start",
        transition: "all 0.3s ease-in-out !important",
        paddingLeft: !open ? '0px' : '0',
        // paddingBottom:'150px',
        '& .iconSideMenu': {
          color: `${sidemenutheme?.iconColor} `,

          fontSize: '28px'
        },
        '& .MuiListItemText-root .MuiTypography-root': {
          textAlign: "left",
          font: "normal normal 15px/30px Cairo-Medium !important",
          letterSpacing: "0px",
          color: sidemenutheme?.textitemcolor,
          opacity: "1",
        },
        '& .MuiListItemText-root': {
          display: open ? 'block' : 'none',
          transition: 'opacity 180ms ease, transform 180ms ease',
          opacity: open ? 1 : 0,
          transform: open ? 'translateX(0px)' : 'translateX(8px)',
        },
        '& .MuiButtonBase-root': {
          backgroundColor: 'transparent !important',
          padding: open ? '12px 16px !important' : '0px !important',
          transition: 'background-color 220ms cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 220ms cubic-bezier(0.2, 0.8, 0.2, 1), transform 220ms cubic-bezier(0.2, 0.8, 0.2, 1)',
          willChange: 'transform',
          display: 'flex',
          alignItems: 'center',
          justifyContent: open ? 'flex-start' : 'center',
        },
        '& .MuiListItem-root': {
          position: 'relative',
          borderRadius: open ? '16px' : '50%',
          width: open ? '92%' : '48px',
          height: '48px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          alignContent: 'center',
          transition: 'background-color 220ms cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 220ms cubic-bezier(0.2, 0.8, 0.2, 1), transform 220ms cubic-bezier(0.2, 0.8, 0.2, 1)',
          backgroundColor: open ? 'transparent' : 'rgba(255, 255, 255, 0.55)',
          border: open ? 'none' : '1px solid rgba(255, 255, 255, 0.55)',
          backdropFilter: open ? 'none' : 'blur(12px)',
          boxShadow: open ? 'none' : `0px 10px 24px ${sidemenutheme?.secondaryColor}1a`,
        },
        '& .MuiListItem-root:hover': {
          backgroundColor: open ? `${sidemenutheme.itmeshover} !important` : 'rgba(255, 255, 255, 0.72) !important',
          transform: 'translateY(-1px)',
          boxShadow: `0px 14px 32px ${sidemenutheme?.secondaryColor}28`,
        },
        '& .MuiListItem-root:hover .iconSideMenu': {
          color: `${sidemenutheme?.secondaryColor} !important`
        },
        '& .MuiListItem-root:hover .MuiListItemText-root .MuiTypography-root': {
          color: `${sidemenutheme?.secondaryColor} !important`
        },
        '& .MuiListItemButton-root:active': {
          transform: 'translateY(0px) scale(0.98)',
        },
        '& .active .MuiListItem-root': {
          backgroundColor: open ? `${sidemenutheme.itmeshover} !important` : 'rgba(255, 255, 255, 0.78) !important',
          boxShadow: open ? 'none' : `0px 14px 34px ${sidemenutheme?.secondaryColor}2e`,
        },
        '& .active .MuiListItem-root::after': {
          content: '""',
          position: 'absolute',
          inset: '0px',
          borderRadius: 'inherit',
          boxShadow: open ? 'none' : 'inset 0 0 0 1px rgba(255, 255, 255, 0.85)',
          pointerEvents: 'none',
        },
        '& .active .iconSideMenu': {
          color: `${sidemenutheme?.secondaryColor} !important`,
        },
        '& .active .MuiListItemText-root .MuiTypography-root': {
          color: sidemenutheme?.secondaryColor + ' !important',
        },
        "& .menuDropDownHeader": {
          backgroundColor: `${sidemenutheme?.dropdwoncolor} !important`,
          borderRadius: open ? '16px' : '50%',
          width: open ? '92%' : '48px',
          height: '48px',
          transition: 'background-color 220ms cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 220ms cubic-bezier(0.2, 0.8, 0.2, 1), transform 220ms cubic-bezier(0.2, 0.8, 0.2, 1)',
          background: open ? `${sidemenutheme?.dropdwoncolor}` : 'rgba(255, 255, 255, 0.55)',
          border: open ? 'none' : '1px solid rgba(255, 255, 255, 0.55)',
          backdropFilter: open ? 'none' : 'blur(12px)',
          boxShadow: open ? 'none' : '0px 10px 24px rgba(102, 37, 0, 0.10)',
        },
        "& .menuDropDownHeader:hover": {
          transform: 'translateY(-1px)',
          boxShadow: '0px 14px 32px rgba(102, 37, 0, 0.16)',
        },
        "& .menuDropDownHeader .itmdropdown svg,& .menuDropDownHeader .itmdropdown .MuiTypography-root ": {
          color: sidemenutheme?.colorWhite + ' !important',
          cursor: 'pointer !important',
        },
        "& .itmContainerdropdown  .itmdropdown svg": {

          color: sidemenutheme?.secondaryColor + ' !important',
        },
        "& .menuDropDownCollapse": {
          position: 'relative',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          marginTop: '4px',
          paddingBottom: '4px',
        },
        "& .menuDropDownCollapse::before": {
          content: '""',
          position: 'absolute',
          top: '0',
          bottom: '24px',
          insetInlineStart: '52px',
          width: '1px',
          background: 'rgba(36, 34, 32, 0.15)',
          zIndex: 0,
        },
        "& .menuSubItem": {
          backgroundColor: 'transparent !important',
        },
        "& .menuSubItem:hover": {
          backgroundColor: 'transparent !important',
        },
        "& .menuSubItem .MuiListItem-root": {
          width: '92%',
          marginInline: 'auto',
          borderRadius: '0',
          height: '44px',
          backgroundColor: 'transparent !important',
          boxShadow: 'none !important',
          marginBottom: '4px',
          border: 'none',
        },
        "& .menuSubItem .MuiListItem-root:hover": {
          backgroundColor: 'transparent !important',
          boxShadow: 'none !important',
          transform: 'none !important',
        },
        "& .menuSubItem .MuiListItemButton-root": {
          position: 'relative',
          justifyContent: 'flex-start',
          paddingInlineStart: '80px !important',
          paddingInlineEnd: '16px !important',
          paddingBlock: '8px !important',
          borderRadius: '0 !important',
          backgroundColor: 'transparent !important',
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          width: '100%',
        },
        "& .menuSubItem .MuiListItemIcon-root": {
          display: 'none',
        },
        "& .menuSubItem .MuiListItemText-root": {
          margin: 0,
          flex: 'none',
        },
        "& .menuSubItem .MuiListItemText-root .MuiTypography-root": {
          display: 'inline-block',
          padding: '8px 20px',
          borderRadius: '16px',
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          backgroundColor: 'transparent',
        },
        "& .menuSubItem:hover .MuiListItemText-root .MuiTypography-root": {
          backgroundColor: `${sidemenutheme?.secondaryColor}22`,
        },
        "& .menuSubItem.active .MuiListItemText-root .MuiTypography-root": {
          backgroundColor: `${sidemenutheme?.secondaryColor}33`,
          color: `${sidemenutheme?.secondaryColor} !important`,
          fontWeight: '600 !important',
        },
        "& .menuSubItem .MuiListItemButton-root::before": {
          content: '""',
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          insetInlineStart: '52px',
          width: '24px',
          height: '20px',
          borderInlineStart: '1.5px solid rgba(36, 34, 32, 0.18)',
          borderBlockEnd: '1.5px solid rgba(36, 34, 32, 0.18)',
          borderEndStartRadius: '12px',
          zIndex: 0,
        }
      }}
      ref={listRef}

    >
      {pathsList && pathsList?.length > 0 && pathsList?.filter(item => item?.hasRole(rolesRedux))?.map((obj, index) => (
        <>
          {obj && obj?.subLink?.length === 0 ?
            <NavLink
              to={obj?.to} key={obj?.name + "_" + obj?.id}
              onClick={() => {
                setOpen(false)
                dispatch(setCurrentlyOpendMenuItem(obj));
              }}
              style={{
                width: '100%',
                display: "flex",
                justifyContent: "center",
                alignItems: "center",

              }}
              ref={obj?.ref}
            >
              <ListItem disablePadding sx={{ display: 'block', mt: '10px' }} disableRipple>
                <ListItemButton
                  disableRipple
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: open ? 2.5 : 0,
                  }}
                >
                  {
                    obj?.id === 7 && open ?
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 3 : 0,
                              justifyContent: 'center',
                            }}
                          >
                            {obj?.icon && obj?.icon(open)}
                          </ListItemIcon>
                          <ListItemText primary={obj?.name} sx={{ opacity: open ? 1 : 0 }} />
                        </Box>

                      </Box> : <>
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : 0,
                            justifyContent: 'center',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          {obj?.icon && obj?.icon(open)}
                        </ListItemIcon>
                        <ListItemText primary={obj?.name} sx={{ opacity: open ? 1 : 0 }} />
                      </>
                  }
                </ListItemButton>
              </ListItem>
            </NavLink>
            : obj ?
              <Tooltip
                title={
                  !open && obj?.subLink?.length > 0 ? (
                    <Box sx={{
                      padding: '12px 8px',
                      minWidth: '180px',
                      fontFamily: '"Cairo", sans-serif',
                    }}>
                      {/* Menu Title */}
                      <Typography sx={{
                        fontWeight: 700,
                        fontSize: '14px',
                        fontFamily: '"Cairo", sans-serif',
                        color: sidemenutheme?.secondaryColor || '#333',
                        marginBottom: '12px',
                        paddingBottom: '8px',
                        borderBottom: `1px solid ${sidemenutheme?.secondaryColor}33`,
                      }}>
                        {obj?.name}
                      </Typography>
                      {/* Submenu Items */}
                      {obj?.subLink?.filter(item => item?.hasRole(rolesRedux))?.map((sub, idx) => (
                        <NavLink
                          to={sub?.to}
                          key={`tooltip-${sub?.name}-${idx}`}
                          style={{ textDecoration: 'none' }}
                        >
                          <Box sx={{
                            padding: '10px 14px',
                            borderRadius: '10px',
                            marginBottom: '4px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            backgroundColor: 'transparent',
                            '&:hover': {
                              backgroundColor: `${sidemenutheme?.secondaryColor}22`,
                              transform: 'translateX(4px)',
                            },
                          }}>
                            <Typography sx={{
                              fontSize: '13px',
                              fontWeight: 500,
                              fontFamily: '"Cairo", sans-serif',
                              color: sidemenutheme?.textitemcolor || '#555',
                            }}>
                              {sub?.name}
                            </Typography>
                          </Box>
                        </NavLink>
                      ))}
                    </Box>
                  ) : (!open ? obj?.name : '')
                }
                placement="left"
                arrow
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 300 }}
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: 'rgba(255, 255, 255, 0.95)',
                      backdropFilter: 'blur(20px)',
                      boxShadow: `0px 8px 32px ${sidemenutheme?.secondaryColor}33, 0px 4px 16px rgba(0,0,0,0.1)`,
                      borderRadius: '16px',
                      border: `1px solid ${sidemenutheme?.secondaryColor}22`,
                      color: sidemenutheme?.textitemcolor || '#333',
                      fontFamily: '"Cairo", sans-serif',
                      padding: '4px',
                      maxWidth: '280px',
                      '& .MuiTooltip-arrow': {
                        color: 'rgba(255, 255, 255, 0.95)',
                        '&::before': {
                          border: `1px solid ${sidemenutheme?.secondaryColor}22`,
                          backgroundColor: 'rgba(255, 255, 255, 0.95)',
                        }
                      }
                    }
                  },
                  arrow: {
                    sx: {
                      color: 'rgba(255, 255, 255, 0.95)',
                    }
                  }
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: open ? 'space-between' : 'center',
                    alignItems: 'center',
                    width: open ? '92%' : '48px',
                    height: '48px',
                    mt: '10px',
                    cursor: 'pointer'
                  }}
                  className="menuDropDownHeader" onClick={(e) => { openCollapseToggle(obj, e) }}
                  ref={obj?.ref}
                >
                  <Box sx={{ display: 'flex', justifyContent: open ? 'start' : 'center', alignItems: 'center', width: '100%' }}>
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 6 : 0,
                        justifyContent: 'center',
                        position: 'relative',
                        left: open ? '20px' : '0px'
                      }}
                      className="itmdropdown"
                    >
                      {obj?.icon && obj?.icon(open)}
                    </ListItemIcon>
                    <ListItemText className='itmdropdown' primary={obj?.name} sx={{ display: open ? 'block' : 'none', opacity: open ? 1 : 0 }} />
                  </Box>
                  {
                    open ? (!obj?.openCollapse ?
                      <RiIcons.RiArrowDropDownLine style={{ fontSize: '30px', color: maintheme?.primary }} className='itmdropdown' /> :
                      <RiIcons.RiArrowDropUpLine style={{ fontSize: '30px', color: maintheme?.primary }} className='itmdropdown' />)
                      : null
                  }
                </Box>
              </Tooltip> : null
          }
          {
            obj && obj?.subLink?.length > 0 ?
              <Collapse isOpened={obj?.openCollapse && open} className="menuDropDownCollapse">
                {/* <List> */}
                {obj?.subLink?.filter(item => item?.hasRole(rolesRedux))?.map((sub) => (
                  <NavLink
                    to={sub?.to} key={sub?.name + "_" + sub?.id}
                    className='itmContainerdropdown itmdropdown menuSubItem'
                    ref={sub?.ref}
                    onClick={() => openCollapseToggle2(sub)}
                    style={{
                      width: '100%',
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <ListItem disablePadding sx={{ display: 'block', mt: '8px' }} disableRipple className='itmContainerdropdown itmdropdown '>
                      <ListItemButton
                        disableRipple
                        sx={{
                          minHeight: 44,
                          justifyContent: 'flex-start',
                          px: 0,
                        }}
                      >
                        <ListItemText primary={sub?.name} sx={{ opacity: open ? 1 : 0, margin: 0 }} />
                      </ListItemButton>
                    </ListItem>
                  </NavLink>
                ))}
              </Collapse> : null
          }
        </>
      ))}
    </List>
  )
}
